
// 詳細画面
$(() => {
    if (document.getElementById('agent-contract-detail') != null) {
        setUpWatch();

        $('.js-watch').on('click', function(event) {
            var contract_id = $('input:hidden[name="contract_id"]').val();
            var user_id = $('input:hidden[name="user_id"]').val();

            $.ajax({
                type: 'POST',
                url: '/agent/contract/detail/edit/watch',
                data: {
                    'id': user_id,
                    'contract_id' : contract_id
                },
                dataType: 'json', //json形式で受け取る
            }).done(function (data) {
                if(data) {
                    // ウォッチ開始
                    $('.js-watch').children().css('color', 'red');

                }
                else {
                    // ウォッチ解除
                    $('.js-watch').children().css('color', '');
                }
            });
        });
    }
});

function setUpWatch()
{
    var watch = $('input:hidden[name="watch"]').val();
    if (watch == 1) {
        // ウォッチ中
        $('.js-watch').css('color', 'red');
    }
}
